import React from 'react';
import { CardLabel, FunCard } from './GameUI';

const INTRO_MS = 1200;
const BEAT_MS = 1100;
const GO_MS = 1000;

const BEATS = [
  { label: '3', tone: 'violet' },
  { label: '2', tone: 'pink' },
  { label: '1', tone: 'orange' },
  { label: 'GO!', tone: 'go' },
];

const SPARKS = ['🎉', '⭐', '✨', '💥', '🎈', '⭐', '✨', '🎉'].map((emoji, i, all) => {
  const angle = (i / all.length) * 2 * Math.PI - Math.PI / 2;
  return { emoji, dx: `${Math.round(Math.cos(angle) * 150)}px`, dy: `${Math.round(Math.sin(angle) * 150)}px` };
});

class Countdown extends React.Component {
  state = { step: -1 };

  componentDidMount() {
    this.timer = setTimeout(this.advance, INTRO_MS);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  advance = () => {
    const step = this.state.step + 1;
    if (step >= BEATS.length) {
      this.props.onDone();
      return;
    }
    this.setState({ step });
    this.timer = setTimeout(this.advance, step === BEATS.length - 1 ? GO_MS : BEAT_MS);
  };

  renderBeat(step) {
    const beat = BEATS[step];
    const isGo = beat.tone === 'go';
    return (
      <div
        key={step}
        className={`gpCountdown__beat gpCountdown__beat--${beat.tone}`}
        style={{ '--gp-beat': `${isGo ? GO_MS : BEAT_MS}ms` }}
      >
        {!isGo && (
          <svg className="gpCountdown__ring" viewBox="0 0 120 120" aria-hidden="true">
            <circle cx="60" cy="60" r="56" />
          </svg>
        )}
        <span className="gpCountdown__number">{beat.label}</span>
        {isGo && SPARKS.map((s, i) => (
          <span
            key={i}
            className="gpCountdown__spark"
            style={{ '--gp-dx': s.dx, '--gp-dy': s.dy }}
            aria-hidden="true"
          >
            {s.emoji}
          </span>
        ))}
      </div>
    );
  }

  render() {
    const { activity } = this.props;
    const { step } = this.state;
    return (
      <div className="gpCountdown">
        <span className="gpCountdown__kicker">🔥 GET READY!</span>
        <h1 className="gpCountdown__title">{activity.title}</h1>
        <div className="gpCountdown__stage" role="timer" aria-live="assertive" aria-atomic="true">
          {step < 0 ? <span className="gpCountdown__ready">Ready?</span> : this.renderBeat(step)}
        </div>
        {!!activity.body && (
          <FunCard entranceIndex={1} className="gpCountdown__tip">
            <CardLabel emoji="💡" text="How to play" />
            <p className="gpBody">{activity.body}</p>
          </FunCard>
        )}
      </div>
    );
  }
}

export default Countdown;
